/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Clock = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12 1C18.0751 1 23 5.92486 23 12C23 18.0751 18.0751 23 12 23C5.92486 23 1 18.0751 1 12C1 5.92486 5.92486 1 12 1ZM12 2.65C6.83614 2.65 2.65 6.83614 2.65 12C2.65 17.1638 6.83614 21.35 12 21.35C17.1638 21.35 21.35 17.1638 21.35 12C21.35 6.83614 17.1638 2.65 12 2.65ZM12.75 5V11.25H18V12.75H11.25V5H12.75Z"
                        fill={color}
                    />
                </svg>
        );
    };
